/** @format */

import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { SetDocumentFn } from '../../utils'
import { _$ } from 'kpc-react'
import Alarm from '../../containers/MonitorGeneral/GeneralAlarm'
import Cost from '../../containers/MonitorGeneral/GeneralCost'
import Resource from '../../containers/MonitorGeneral/GeneralResource'
import ProductDy from '../../containers/MonitorGeneral/GenetalProductDy'
// import GeneralAlermTask from '../../containers/MonitorGeneral/GeneralAlermTask'
import MonitorCrumb from 'src/components/MonitorCrumb'
import '../../static/styles/general.styl'

const General: FunctionComponent<any> = ({ className }, props) => {
  return (
    <div className={className} id="ksc-general">
      <MonitorCrumb
        breadArr={[{ title: _$('概览') }]}
        rightComponent={<a onClick={() => SetDocumentFn('28122')}>{_$('quick_start')}</a>}
      />
      <Resource />
      <div className="middle_content">
        <Alarm />
        <ProductDy />
      </div>
      {/* 事件告警概览 */}
      {/* <GeneralAlermTask /> */}
      {/* 成本优化 */}
      <Cost />
    </div>
  )
}

export default styled(General)`
  .middle_content {
    display: flex;
    height: 421px;
    margin-top: 20px;
  }
`
